import { UserState } from '../interface/MyInterfaces';

export const resolveUniversityListName = (item) => {
    if (!item) return '';
    return item.university
        || (item.the_university && item.the_university.replace(/^the /i, ''))
        || '';
};

export const formatCddrUniversityDisplayName = (name) => {
    if (!name) return '';
    return name === 'AGG_All_IRIS_Members' ? 'All IRIS Universities' : name;
};

export const resolveCddrUniversityNameFromList = (list, displayId) => {
    if (!displayId || !list) return '';
    const item = list.find(u => String(u.display_id) === String(displayId));
    return resolveUniversityListName(item);
};

export const getReportUniversityName = (userState: UserState) => {
    if (!userState) return '';

    const nameFromList = resolveCddrUniversityNameFromList(
        userState.UniversityListDetailedDistrictReport,
        userState.report_display_id
    );
    if (nameFromList) return formatCddrUniversityDisplayName(nameFromList);

    return formatCddrUniversityDisplayName(
        userState.report_university_name
        || userState.report_university_name_initial
        || userState.university
        || ''
    );
};
